"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const FaqItemStyled_1 = __importDefault(require("./FaqItemStyled"));
const PosaTemplate_1 = __importDefault(require("./PosaTemplate"));
const prop_types_1 = __importDefault(require("prop-types"));
const FaqItem = ({ data, defaultExpand = true }) => {
    const answerRef = react_1.useRef();
    const { question, answer } = data;
    const [expand, toggle] = react_1.useState(defaultExpand);
    react_1.useEffect(() => {
        const ele = answerRef.current;
        if (expand) {
            ele.style.maxHeight = `${ele.scrollHeight}px`;
        }
        else {
            ele.style.maxHeight = 0;
        }
    });
    const onClick = react_1.useCallback(() => {
        toggle(!expand);
    }, [toggle, expand]);
    return (react_1.default.createElement(FaqItemStyled_1.default, { expand: expand, className: `ecr-faqItem ${expand ? 'expand' : ''}` },
        react_1.default.createElement("div", { className: "ecr-faqItem-question", onClick: onClick, role: "presentation" },
            react_1.default.createElement("h3", null, question),
            react_1.default.createElement("div", { className: "expand-icon" })),
        react_1.default.createElement("div", { className: "ecr-faqItem-answer", ref: answerRef },
            react_1.default.createElement(PosaTemplate_1.default, { Tag: "div", isTemplate: true, string: answer }))));
};
FaqItem.propTypes = {
    data: prop_types_1.default.object,
    defaultExpand: prop_types_1.default.bool
};
exports.default = FaqItem;
//# sourceMappingURL=FaqItem.js.map